import { createSlice } from '@reduxjs/toolkit'
import { ModalState } from './types'

export const initialModalState: ModalState = {
  active: false,
  className: '',
  type: ''
}

export const modalSlice = createSlice({
  name: 'modal',
  initialState: initialModalState,
  reducers: {
    toggleModal: (state, action: { payload: Partial<ModalState> }) => {
      // If payload is empty or just {}, close the modal
      if (!action.payload || Object.keys(action.payload).length === 0) {
        return initialModalState // Reset to initial state (active: false)
      }
      return action.payload as ModalState
    }
  }
})

export const reducer = modalSlice.reducer

export const { toggleModal } = modalSlice.actions
